<header class="d-flex justify-content-between">
  <div class="logo-title-row d-flex align-items-center" (click)="openHome()">
    <div class="main-logo-wrapper d-flex align-items-center">
      <img
        class="main-logo"
        [src]="'/assets/images/gesztenye_logo_white_filled.png'"
      />
    </div>
    <div class="logo-title" [class.transparent-mode]="transparentMode">
      {{ "MAIN.APP_NAME" | translate }}
    </div>
  </div>

  <div>
    <nav mat-tab-nav-bar>
      <div
        mat-tab-link
        class="desktop-menu-link"
        *ngFor="let tab of tabsConfig"
        [routerLink]="tab.route"
        on
        routerLinkActive
        #rla="routerLinkActive"
        [class.transparent-mode]="transparentMode"
        [ngClass]="tab.route"
        [active]="rla.isActive"
      >
        <ng-container *ngIf="tab.key !== 'home'">
          {{ tab.key | translate }}
        </ng-container>
      </div>
    </nav>

    <button
      *ngIf="isLoggedIn"
      mat-button
      class="exit-button"
      (click)="logout()"
    >
      <mat-icon class="dark" matSuffix>{{ "exit_to_app" }}</mat-icon>
    </button>
  </div>
</header>
